import { useMemo } from 'react'
import useMosInfo from '../../../common/provider/useMosInfo'
import { useJobData } from '../../ActiveSingleJob/hooks/useJobData'
import { useSmartTranslation } from '../../../../../generic/hooks/useSmartTranslation'

/**
 * High-level hook to manage state and data
 * for the active multi-job widget.
 *
 * Encapsulates:
 * - Selected job data and progress (useJobData)
 * - List of active jobs on the device
 * - Progress percentage for each active job in the list
 * - Context references (device, worker, selectNode, unSelectNode)
 *
 * @returns {Object} State and actions for ActiveMultiJob
 */
export const useActiveMultiJob = () => {
  const { t_ } = useSmartTranslation()

  const {
    jobProgress,
    activeItems,
    fabricationOrder,
    jobReference,
    node,
    reloadProgress,
    refreshActiveJobs,
    materials
  } = useJobData()

  const {
    device,
    worker,
    selectNode,
    unSelectNode,
    activeJobsProgress,
    refreshActiveJobsProgress,
    machineStorage
  } = useMosInfo()

  const plannedEffective = useMemo(
    () => jobProgress?.plannedEffective ?? 0,
    [jobProgress?.plannedEffective]
  )

  return {
    t_,
    jobProgress,
    activeItems,
    fabricationOrder,
    jobReference,
    node,
    reloadProgress,
    refreshActiveJobs,
    materials,
    device,
    worker,
    selectNode,
    unSelectNode,
    listProgress: activeJobsProgress,
    plannedEffective,
    refreshActiveJobsProgress,
    machineStorage
  }
}
